import * as Cookie from 'tiny-cookie';

export default (config, options) => {
  const vendorImg = require('mggp-vendor-img');
  const vendorHls = require('mggp-vendor-hls');
  const vendorDash = require('mggp-vendor-dash');
  const vendorGroupedPrograms = require('mggp-vendor-grouped-programs');
  const vendorHtml5 = require('mggp-vendor-html5');
  const vendorIma = require('mggp-vendor-ima');
  const vendorYandex = require('mggp-vendor-yandex');
  const vendorVPAIDJS = require('mggp-vendor-vpaidjs');
  const vendorChromecast = require('mggp-vendor-chromecast');
  const vendorHtml = require('mggp-vendor-html');
  const vendorHlsFairplay = require('mggp-vendor-hls-fairplay');
  const pluginAudio = require('mggp-plugin-audio');
  const pluginSubtitles = require('mggp-plugin-subtitles');
  const pluginQuality = require('mggp-plugin-quality');
  const pluginGa = require('mggp-plugin-ga');
  const pluginThumbnails = require('mggp-plugin-thumbnails-web');
  const pluginAd = require('mggp-plugin-ad');
  const pluginKibana = require('mggp-plugin-kibana');
  const pluginKibanaWarnings = require('mggp-plugin-kibana-warnings');
  const pluginWss = require('mggp-plugin-wss');
  const pluginComscore = require('mggp-plugin-comscore');
  const pluginGemius = require('mggp-plugin-gemius');
  const pluginChromecast = require('mggp-plugin-chromecast');
  const pluginVodChannelsCms = require('mggp-plugin-vod-channels-cms');
  const pluginDvrCms = require('mggp-plugin-dvr-cms');
  const pluginAirplay = require('mggp-plugin-airplay');
  const pluginLiveDvr = require('mggp-plugin-live-dvr');
  const pluginEpg = require('mggp-plugin-epg');
  const pluginPip = require('mggp-plugin-pip');
  const pluginMet = require('mggp-plugin-met');
  const pluginSkipIntro = require('mggp-plugin-skip-intro');
  const pluginInteractive = require('mggp-plugin-interactive');
  const pluginEpg2 = require('mggp-plugin-epg2');

  //config.loader = require('./../utils/hlsLoader').default;

  const {
    userAgent: { browser, os, device },
  } = config;

  const needModules = [];

  if (Cookie.get('testMobile') === '1') {
    vendorHtml5.mimeTypes = vendorHtml5.mimeTypes.filter((t) => t !== 'm3u8');
  }

  push('vendorHtml5', vendorHtml5);
  push('vendorHls', vendorHls);
  push('vendorHtml', vendorHtml);
  push('pluginGa', pluginGa);
  push('pluginWss', pluginWss);

  if (!config.lite) {
    push('pluginAudio', pluginAudio);
    push('pluginQuality', pluginQuality);
    push('pluginSubtitles', pluginSubtitles);
    push('pluginKibana', pluginKibana);
    push('pluginKibanaWarnings', pluginKibanaWarnings);
    push('pluginGemius', pluginGemius);
    push('pluginComscore', pluginComscore);
    push('pluginChromecast', pluginChromecast);
    push('vendorChromecast', vendorChromecast);
    push('vendorDash', vendorDash);
    push('vendorGroupedPrograms', vendorGroupedPrograms);
    push('pluginAirplay', pluginAirplay);
    push('pluginLiveDvr', pluginLiveDvr);
    push('pluginEpg', pluginEpg);
    push('pluginEpg2', pluginEpg2);

    push('pluginDvrCms', pluginDvrCms);
    push('pluginVodChannelsCms', pluginVodChannelsCms);
    push('pluginPip', pluginPip);
    push('pluginMet', pluginMet);
    push('pluginSkipIntro', pluginSkipIntro);
    push('pluginInteractive', pluginInteractive);

    if (!options.isMobile) {
      push('pluginThumbnails', pluginThumbnails);
    }
  }

  if (config.ad) {
    push('pluginAd', pluginAd);
    push('vendorImg', vendorImg);
    push('vendorIma', vendorIma);
    push('vendorVPAIDJS', vendorVPAIDJS);
    push('vendorYandex', vendorYandex);
  }

  // MHP-1458 По дефолту у вендора Html5 и HLS priority = 0, в итоге в части случаев для m3u8 применяется вендор html5
  // проблема в том что он работает не всегда корректно и лучше использовать вендор HLS
  if (os.name === 'Android') {
    vendorHtml5.priority = 1;
  }

  // Проблема описаная в тикете касалась iOS, а не Android
  // но если смотреть шире и считать что vendor-hls предпочтительней,
  // и в нём уже исправлены проблемы, все еще присутсвующие в vendor-html5,
  // то зачем нам вообще использовать html5?
  if (os.name === 'iOS') {
    vendorHtml5.priority = 1;
  }

  if (browser.name === 'Safari' && os.name === 'Mac OS') {
    if (Number(browser.major) >= 10) {
      vendorHtml5.priority = 1;
    }
  }

  if (device.vendor === 'Apple') {
    push('vendorHlsFairplay', vendorHlsFairplay);
  }

  config.externalModules.forEach((module) => {
    push('module', module);
  });

  return needModules;

  function push(name, module) {
    module.id = name;
    needModules.push({ name, module });
  }
};
